<div class="bg-image " style=" font-family: 'Li Ador Noirrit SemiBold';">


    <div class="container-fluid" style=" padding-bottom: 30px;">
        <div class="row">
            <div class="col-md-12">
                <div style="min-height: 150px;">
                    <div class="page-title-content portfolio-agency-banner pa-bg1 jarallax"
                        style="height: 120px;width: 100%;padding-top: 0%;">
                        <h2
                            style="color: aliceblue;text-align: center;padding-bottom: -10px !important;padding-top: 35px !important; ">
                            {{inputData.TitleEn}}</h2>
                    </div>
                    <div class="container-fluid" style="padding: 20px;">
                        <!-- <div *ngIf="inputData.ShowAttachments" style="margin-bottom: 40px;">
                            <img class="img-fluid"
                                style="height: 450px; width: 100%; object-fit: cover; border-radius: 10px;"
                                [src]="inputData.ShowAttachments[0].FilePath">
                        </div> -->

                        <div class="container-fluid" style="text-align: justify !important;"
                            *ngIf="inputData.DetailsEn">
                            <div class="row">
                                <div class="col-md-12" style="font-family: 'Li Ador Noirrit SemiBold';font-size: 18px;"
                                    [innerHTML]="inputData.DetailsEn">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>